import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const LoadingWave = () => {
  return (
    <div style={{ display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'center' }}>
      <DotLottieReact
    src="https://lottie.host/05ca1554-4179-40cd-9c46-93f88f026aad/9JTsc5r4oK.lottie" 
      loop
      autoplay
       style={{ width: 500, height: 500 }}
    />
    </div>
  );
};

export default LoadingWave;
